<!--
 * @Author: Yuan Cong <email: wso2848303@163.com> <tel: 15821618224>
 * @Date: 2021-01-26 16:34:12
 * @LastEditors: Yuan Cong <email: wso2848303@163.com> <tel: 15821618224>
 * @LastEditTime: 2021-05-11 23:19:13
 * @Description: 菜单图标
 * @FilePath: \hsylc2021\src\components\icons\Menu\index.vue
-->
<template>
  <div class="icon-menu" :class="computedClass" :style="componentStyle" @click="handleClick">
    <div class="menu-line" :style="lineStyle"></div>
    <div class="menu-line" :style="lineStyle"></div>
    <div class="menu-line" :style="lineStyle"></div>
    <div class="menu-line" :style="lineStyle"></div>
    <div class="menu-line" :style="lineStyle"></div>
    <div class="menu-line" :style="lineStyle"></div>
    <div class="menu-line" :style="lineStyle"></div>
  </div>
</template>
<script>
/**
 * 菜单图标
 * @module Menu
 */
export default {
  name: 'Menu',
  /**
   * @prop {String} className 外部类
   * @prop {String} color 图标颜色 默认#FFF
   * @prop {String} width 组件大小 默认20px
   */
  props: {
    className: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: '#FFF'
    },
    width: {
      type: String,
      default: '20px'
    }
  },
  /**
   * @prop {Object} computedClass 组件class
   * @prop {Object} componentStyle 组件style
   * @prop {Object} lineStyle 图标style
   */
  computed: {
    computedClass() {
      let ret = {};
      ret[this.className] = true;
      return ret;
    },
    componentStyle() {
      let ret = {};
      ret.width = ret.height = this.width;
      return ret;
    },
    lineStyle() {
      let ret = {};
      ret.backgroundColor = this.color;
      return ret;
    }
  },
  methods: {
    /**
     * @event click 暴漏点击事件
     */
    /**
     * @description 点击事件
     * @function handleClick
     */
    handleClick: function() {
      this.$emit('click', this.id);
    }
  }
};
</script>
<style lang="less" scoped>
.icon-menu {
  .menu-line {
    width: 90%;
    margin: 0 auto;
    height: calc(100% / 7);
    &:nth-of-type(odd) {
      visibility: hidden;
    }
  }
}
</style>
